// api.ts
import axios from 'axios'
import endpoints from '../../endpoints'
import {ClassBase} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchClassList(): Promise<APIResponse<ClassBase[]>> {
  const response = await axios.get(API_URL + endpoints.class.list)
  return response.data
}

export async function createClass(body: Omit<ClassBase, 'class_id'>): Promise<APIResponse<null>> {
  const response = await axios.put(API_URL + endpoints.class.create, body)
  return response.data
}

export async function updateClass(body: ClassBase): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.class.update, body)
  return response.data
}

export async function deleteClass(classId: string): Promise<APIResponse<null>> {
  const response = await axios.delete(API_URL + endpoints.class.delete + classId)
  return response.data
}
